import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Box,
  IconButton
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const OrderTrackingDialog = ({ open, trackingOrder, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm")); // mobile detect
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!trackingOrder) return null;

  const statusSteps = ["Pending", "Processing", "ReadyToPack", "Shipped", "Delivered"];
  const currentStep = statusSteps.indexOf(trackingOrder.status);

  return (
    <Dialog open={!!trackingOrder} onClose={onClose} fullWidth maxWidth="sm" fullScreen={fullScreen}>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: isMobile ? "flex-start" : "space-between",
          pr: 2
        }}
      >
        {/* ✅ Mobile pe Back Button left side */}
        {isMobile && (
          <IconButton onClick={onClose} edge="start" aria-label="back" sx={{ mr: 1 }}>
            <ArrowBack />
          </IconButton>
        )}

        <Typography variant="h6" sx={{ flexGrow: 1, textAlign: isMobile ? "left" : "center" }}>
          Order Tracking
        </Typography>

        {/* ✅ Desktop pe Back Button right side */}
        {!isMobile && (
          <IconButton onClick={onClose} edge="end" aria-label="back">
            <ArrowBack />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent>
        <Typography variant="h6">Order ID: {trackingOrder.orderId}</Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Expected Delivery: {trackingOrder.expectedDelivery}
        </Typography>

        {/* Stepper for Order Status */}
        <Box sx={{ mt: 3, mb: 2 }}>
          <Stepper activeStep={currentStep} alternativeLabel>
            {statusSteps.map((step, index) => (
              <Step key={index}>
                <StepLabel
                  sx={{
                    "& .MuiStepLabel-label": {
                      fontSize: { xs: "0.75rem", sm: "0.875rem" }
                    }
                  }}
                >
                  {step}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        {/* Current Status Message */}
        <Typography
          variant="body1"
          sx={{ textAlign: "center", mt: 2, fontWeight: "bold", color: "green" }}
        >
          Current Status: {trackingOrder.status}
        </Typography>

        {/* ✅ Delivery Boy Section */}
        {trackingOrder?.deliveryBoyName && (
          <Box mt={2}>
            <Typography variant="subtitle1" fontWeight="bold">
              Delivery Agent Details:
            </Typography>
            <Typography>Name: {trackingOrder.deliveryBoyName}</Typography>
            <Typography>Mobile: {trackingOrder.deliveryBoyMobile}</Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default OrderTrackingDialog;
